import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { ArenaCompetition } from '@sparro/app/core/models/competition.model';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';

@Component({
  selector: 'app-prize',
  templateUrl: './prize.component.html',
  styleUrls: ['./prize.component.scss']
})
export class PrizeComponent implements OnInit {
  compSlug: string;
  prizeSlug: string;
  modules: any = [];
  isLoading: boolean = false;
  defaultImage: string = UNI_CONSTANTS.NO_IMAGE.COMP_OR_PROJECT;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public metaService: MetaService,
    private detailService: CompDetailService,
    public imageOptimizer: ImageOptimizerService
  ) {
  }

  ngOnInit(): void {
    this.prizeSlug = this.route.snapshot.params.prize_slug;
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.getPrizeModule();
  }

  ngDoCheck(): void {
    if (this.prizeSlug !== this.route.snapshot.params.prize_slug) {
      this.prizeSlug = this.route.snapshot.params.prize_slug;
      this.compSlug = this.route.parent.snapshot.params.comp_slug;
      this.getPrizeModule();
    }
  }

  getPrizeModule(): void {
    this.isLoading = true;
    this.detailService.awardsModule(this.compSlug, this.prizeSlug).subscribe(
      (response) => {
        this.modules = response;
        this.updateMetaInfo();
        this.isLoading = false;
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      });
  }

  updateMetaInfo(): void {
    this.detailService.fetchCompetition(this.compSlug, (competition: ArenaCompetition) => {
      let metaInfo: MetaDefinition[] = [];
      const prizeArray = [];
      if (this.modules.length && this.modules[0]?.prizes.length) {
        this.modules[0]?.prizes.forEach(prize => {
          prizeArray.push(`${prize.name} ${prize.subtitle}`);
        });
      }
      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location?.country?.name} | ${this.prizeSlug.charAt(0).toUpperCase() +
        this.prizeSlug.slice(1)}`;

      const description = `Prize pool worth upto ${this.modules.length && this.modules[0]?.prizes.length ?
        this.modules[0].prizes[0].prize : '-'} USD.` + (prizeArray.length ? `${prizeArray.join(', ')}.` : '');
      const image = competition.image ? this.renderImage(competition.image) : '';

      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
}
